import { type FC } from "react";

import { useInsightsPageBlizzardEvent } from "../../hooks";

import { EngagementBreakdownSection } from "./EngagementBreakdownSection";
import { EngagementFunnel } from "./engagement-funnel";
import { childFirst } from "./funnelTab.styles";

export const FunnelTab: FC = () => {
    useInsightsPageBlizzardEvent("MY_LENSES_INSIGHTS_FUNNEL_ANALYSIS");

    return (
        <>
            <EngagementFunnel className={childFirst} />
            <EngagementBreakdownSection />
        </>
    );
};
